import type { ComponentType } from "react";
import { Dimension } from "@models/IDimension";
import type { AdvanceSearchDimensionRegistry } from "@modules/advance-search/types";

/**
 * Named dimension implementations available to the advanced-search composition root.
 * The `link` implementation is registered under the historical `Dimension.league` key.
 */
export interface AdvanceSearchDimensionImplementations {
  classroom: ComponentType;
  instructor: ComponentType;
  population: ComponentType;
  course: ComponentType;
  section: ComponentType;
  group: ComponentType;
  link: ComponentType;
  package: ComponentType;
}

/**
 * Builds the complete dimension-keyed registry injected into the generic advanced-search page.
 *
 * @param implementations - Named components owned by each dimension module.
 * @returns An immutable registry covering every supported `Dimension` value.
 */
export const createAdvanceSearchDimensionRegistry = ({
  classroom,
  instructor,
  population,
  course,
  section,
  group,
  link,
  package: packageComponent,
}: AdvanceSearchDimensionImplementations): AdvanceSearchDimensionRegistry => ({
  [Dimension.classroom]: classroom,
  [Dimension.instructor]: instructor,
  [Dimension.population]: population,
  [Dimension.course]: course,
  [Dimension.section]: section,
  [Dimension.group]: group,
  [Dimension.league]: link,
  [Dimension.package]: packageComponent,
});
